import { ApiClientError, type ApiError } from '@/lib/http-core';

/**
 * 회원(users) raw-fetch 훅 전용. BE 에러 응답(envelope)을 읽어 ApiClientError 로 변환해
 * BE 가 내려준 한국어 메시지를 그대로 표면화한다. envelope 가 아니면(HTML SPA fallback 등)
 * status 기반 일반 메시지로 폴백한다.
 */
export const throwFromResponse = async (res: Response, fallback: string): Promise<never> => {
  let env: { success?: boolean; error?: ApiError } | null = null;
  try {
    env = (await res.clone().json()) as { success?: boolean; error?: ApiError };
  } catch {
    env = null;
  }
  if (env && env.success === false && env.error?.message) {
    throw new ApiClientError(env.error, { status: res.status });
  }
  throw new Error(`${fallback} (${res.status})`);
};
